/* eslint-disable react/prop-types */
import React from "react";
import { RemoveRounded, AddRounded, ShoppingCart } from "@mui/icons-material";
import { Button, Typography, Box, Modal } from "@mui/material";
import ExpandableText from "./ExpandableText";
import SelectSize from "./SelectSize";
import { Link } from "react-router-dom";
import { routes } from "../../../helpers/Routes";
import { useAuth } from "../../../hooks/useAuth";
import visa from "../../../assets/visa.svg";
import mastercard from "../../../assets/mastercard.svg";
import americanexpress from "../../../assets/americanexpress.svg";
import codinensa from "../../../assets/codensa.svg";
import visadebito from "../../../assets/visa-debito.svg";
import mastercarddebito from "../../../assets/matercard-debito.svg";
import efecty from "../../../assets/efecty.svg";
import { useSnackbar } from "notistack";
import axios from "axios";
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import { CartButton, ButtonNowShop } from "../../ui/Buttoncart";
import AccordionBikeMethod from './AccordionPage'
import { Toaster, toast } from "react-hot-toast";
const Info = ({ count, setCount, addCart, cantidad, size, onChange, producto, formatoCOP, comprar_ahora, setColor, color, colores, images, setBgimage }) => {
  const { usuario } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

 const rgbToColores = {
    "rgb(255, 255, 255)": "Blanco",
    "rgb(203, 203, 199)": "Champagne",
    "rgb(14, 26, 38)": "Negro",
    "rgb(224, 60, 60)": "Rojo",
    "rgb(70, 73, 77)": "Verde"
  }

  const labelStyle = {
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    borderRadius: 10,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    transition: ".4s"
  };


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const countIncrease = () => {
    const inventory = producto.inventarios.find(inv => inv.color == color.dataC && inv.talla == size)
    if (inventory){
      setCount((prevValue) => Math.min(parseInt(inventory.quantity), prevValue + 1));
    }
  };
  

  const countDecrease = () => {
    setCount((prevValue) => Math.max(0, prevValue - 1));
  };
  function calcularDescuentoPorcentaje(precioOriginal, precioConDescuento) {
    let descuento = precioOriginal - precioConDescuento;
    let porcentajeDescuento = (descuento / precioOriginal) * 100;
    return parseInt(porcentajeDescuento)
  }

  const handleAddCart = () => {
    if (color?.dataC.trim() === "") {
      enqueueSnackbar("Seleccione un color", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        }
      });
      return;
    }
    
    async function getIP() {
      const ip = await axios.get("https://api.ipify.org?format=json");
      return ip.data;  // Devuelve los datos directamente
    }
    
    async function showIP() {
      const data = await getIP();
      addCart({ ...producto, cantidad, id_usuario: usuario?.id_usuario, size: size, ip: data?.ip, color: color.dataC })

    }

    showIP()
    toast.success("Producto añadido al carrito")
  }

  const comprar = () => {
    if (color?.dataC.trim() === "") {
      enqueueSnackbar("Seleccione un color", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        }
      });
      return;
    }
    comprar_ahora(color.dataC, size);
    handleOpen()
  }

  function handleColor(dataC, index){
    setColor({dataC, index})
    const image = images?.find((img) => img.color === dataC)
    setBgimage(image?.url?.secure_url)
  }
  return (
    <div>
      <Toaster></Toaster>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center', borderRadius: "10px" }}>
            Producto añadido!
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, display: 'flex', alignItems: 'center', textAlign: "center", flexDirection: 'column' }}>
            <ShoppingCartCheckoutIcon style={{ fontSize: "60px", color: "green" }}></ShoppingCartCheckoutIcon>
            La bicicleta {producto?.nombre} ha sido añadida al carrito.
          </Typography>
          <div style={{ justifyContent: 'center', display: 'flex', gap: 15, marginTop: "10px" }}>
            <Button sx={{
              bgcolor: 'gray',
              color: '#eee',
              fontWeight: 'bold',
              '&:hover': { bgcolor: 'rgba(53, 50, 47, 0.92)' },
              boxShadow: '0px 6px 5px 2px rgba(61, 57, 53, 0.2)',
            }}
              onClick={handleClose}>
              Cerrar
            </Button>
            <Button sx={{
              bgcolor: 'rgb(201, 197, 3)',
              color: '#eee',
              fontWeight: 'bold',
              '&:hover': { bgcolor: 'yellow' },
              boxShadow: '0px 6px 5px 2px rgba(255, 125, 26, 0.2)',
            }}
              onClick={() => comprar_ahora()}>
              Pagar Ahora
            </Button>
          </div>
        </Box>
      </Modal>

      <Box component="article" className="info" sx={{ maxWidth: 450, margin: 'auto' }}>
        <Typography variant="h4" component="h2" gutterBottom>
          {producto?.nombre}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          <ExpandableText producto={producto} />
        </Typography>
        <Box className="price" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h5" component="h3" fontWeight="bold" mr={1}>
              {formatoCOP.format(producto?.precio)}
            </Typography>
            <Typography variant="p" bgcolor="yellow" color="#000" px={1} py={0.5} borderRadius={1}>
              {calcularDescuentoPorcentaje(producto?.precioAntes, producto?.precio) + "%"}
            </Typography>
          </Box>
          <Typography variant="body2" color="#fff" sx={{ textDecoration: 'line-through' }}>
            {formatoCOP.format(producto?.precioAntes)}
          </Typography>
        </Box>
        <div>Colores:</div>
        <div style={{ display: "flex", gap: "5px", marginBottom: 10 }}>
          {colores?.map((dataC, index) => {
            if (dataC == "") return
            return (
            <button key={index} style={{ backgroundColor: dataC }} onClick={() => handleColor(dataC, index)} className={`${color.dataC == dataC ? "button-active" : ""}`} />
          )})}
        </div>
        <Box className="cart" sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>


          <div>
            <label htmlFor="size-select" style={labelStyle}>
              Cantidad:
            </label>
            <Box className="Add" sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", bgcolor: 'grey.100', borderRadius: 2, p: 1 }}>
              <Button onClick={countDecrease} sx={{ minWidth: 40, color: 'black', outline: 'none' }}>
                <RemoveRounded />
              </Button>
              <Typography sx={{ mx: 2, fontWeight: 'bold' }} className="span-add">{count}</Typography>
              <Button onClick={countIncrease} sx={{ minWidth: 40, color: 'black' }}>
                <AddRounded />
              </Button>
            </Box>

          </div>

          <SelectSize size={size} onChange={onChange} producto={producto} color={color}/>

          <div className="btn-cart-container" style={{ display: 'flex', justifyContent: 'center', gap: 5, width: "100%" }}>

            <CartButton
              className="btn-cart"
              startIcon={<ShoppingCart />}
              onClick={handleAddCart}
              sx={{
                bgcolor: 'rgb(201, 197, 3)',
                color: '#eee',
                fontWeight: 'bold',
                '&:hover': { bgcolor: 'yellow' },
                boxShadow: '0px 6px 5px 2px rgba(255, 125, 26, 0.2)',
              }}
            >
              Agregar al Carrito
            </CartButton>

            <ButtonNowShop
              className="btn-cart btn-cart2"
              variant="contained"
              startIcon={<ShoppingCart />}
              onClick={comprar}
              sx={{
                bgcolor: 'gray',
                color: '#eee',
                fontWeight: 'bold',
                '&:hover': { bgcolor: 'rgba(53, 50, 47, 0.92)' },
                boxShadow: '0px 6px 5px 2px rgba(61, 57, 53, 0.2)',
              }}
            >
              Comprar Ahora
            </ButtonNowShop>
          </div>

          <p>Esta Compra esta sujeta a una <Link to={"/terms"} style={{ cursor: 'pointer' }}>politica de reembolso</Link>. Recibe el producto que esperabas o te devolvemos tu dinero.</p>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <AccordionBikeMethod></AccordionBikeMethod>
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default Info;

